"use client"

import type React from "react"
import { Modal, ModalHeader, ModalBody, Row, Col, Badge } from "reactstrap"
import type { BadgeEntryVerification } from "./types"

interface Props {
  isOpen: boolean
  toggle: () => void
  verificationData: BadgeEntryVerification | null
}

const BadgeEntryVerificationModal: React.FC<Props> = ({ isOpen, toggle, verificationData }) => {
  if (!verificationData) return null

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Badge Verification Details</ModalHeader>
      <ModalBody>
        <Row>
          <Col md="6">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Verification Date & Time</h6>
              <p className="mb-0">
                {new Date(verificationData.created_at).toLocaleDateString()}{" "}
                {new Date(verificationData.created_at).toLocaleTimeString()}
              </p>
            </div>
          </Col>
          <Col md="6">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Verification Code</h6>
              <p className="mb-0">
                <Badge color="secondary">{verificationData.badge_verification_code}</Badge>
              </p>
            </div>
          </Col>
        </Row>

        <hr />

        <Row>
          <Col md="6">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Badge Owner</h6>
              <p className="mb-0">
                <strong>{verificationData.badge_owner_name}</strong>
              </p>
              {verificationData.badge_owner_email && (
                <p className="text-muted small mb-0">{verificationData.badge_owner_email}</p>
              )}
            </div>
          </Col>
          <Col md="6">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Exhibitor</h6>
              <p className="mb-0">
                <Badge color={verificationData.exhibitor_name === "N/A" ? "secondary" : "info"} pill>
                  {verificationData.exhibitor_name}
                </Badge>
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Exhibition</h6>
              <p className="mb-0">
                <strong>{verificationData.exhibition_title}</strong>
              </p>
              <p className="text-muted small mb-0">{verificationData.exhibition_dates}</p>
            </div>
          </Col>
        </Row>

        <hr />

        <Row>
          <Col md="6">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Turnstile Gate Used</h6>
              <p className="mb-0">
                <Badge color="primary" pill>
                  {verificationData.turnstile_number}
                </Badge>
              </p>
            </div>
          </Col>
          <Col md="6">
            <div className="mb-3">
              <h6 className="text-muted mb-1">Entry Helper</h6>
              <p className="mb-0">
                <strong>{verificationData.helper_name}</strong>
              </p>
              {verificationData.helper_email && (
                <p className="text-muted small mb-0">{verificationData.helper_email}</p>
              )}
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default BadgeEntryVerificationModal
